import React from "react"
import Banner from "./components/Banner"
import MainLayout from "../index"
import BuySim from "src/pages/STAFF/BuySim"
import BuyPackge from "src/pages/STAFF/BuyPackage"
import TabSwitcher from "./components/TabSwitcher"

const HomePage = () => {
  const scrollToSection = ref => {
    ref.current?.scrollIntoView({ behavior: "smooth" })
  }
  return (
    <MainLayout>
      <div
        style={{
          height: "calc(100vh - 80px)",
          overflowY: "auto",
        }}
      >
        <Banner />
        <TabSwitcher />
        <div
          id="sim-section"
          style={{
            paddingLeft: "24px",
            paddingRight: "24px",
            scrollMarginTop: "80px",
          }}
        >
          {/* <BuySim /> */}
        </div>
        <div
          id="package-section"
          style={{
            paddingLeft: "24px",
            paddingRight: "24px",
            scrollMarginTop: "80px",
          }}
        >
          <BuyPackge />
        </div>
      </div>
    </MainLayout>
  )
}

export default HomePage
